import React from 'react';
import { observer } from 'mobx-react-lite';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { useRootStore } from '../../../../../mobx/bridge';
import styles from './AutoReplyModalWindow.module.css';
import CustomAwayMessages from '../../CustomAwayMessages/CustomAwayMessages';
import WeeklyScheduledAutoReplies from '../WeeklyScheduledAutoReplies/WeeklyScheduledAutoReplies';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyModalWindow = observer(function AutoReplyModalWindow() {
  const { commonStore } = useRootStore();

  const { t } = useTranslation();

  const handleClose = () => {
    commonStore.setToggleIsManageAutoRepliesPopupOpen();
  };

  return (
    <Modal
      open={commonStore.isManageAutoRepliesPopupOpen}
      onClose={handleClose}
      disableEnforceFocus
      disableAutoFocus
      BackdropProps={{
        className: styles.overlay,
      }}
      closeAfterTransition
      disablePortal
      aria-labelledby={t('AutoReplyModalWindow.ModalTitle')}
    >
      <Fade in={commonStore.isManageAutoRepliesPopupOpen}>
        <div className={styles.autoReplyModalWindow}>
          <Grid component="div" container className={styles.nestedContainer}>
            <Grid component="div" container item xs={12}>
              <h1 className={styles.title}>{t('AutoReplyModalWindow.ModalTitle')}</h1>
              <button
                type="button"
                className={[styles.settingsBtn, styles.closeBtn].join(' ')}
                onClick={handleClose}
                data-testid="settingsCloseBtn"
              />
            </Grid>
            <CustomAwayMessages />
            <WeeklyScheduledAutoReplies />
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
});
AutoReplyModalWindow.whyDidYouRender = true;
AutoReplyModalWindow.displayName = 'AutoReplyModalWindow';

export default AutoReplyModalWindow;
